export const JS_SIP_LOGS_REGEXP = /JsSIP:/;
